import "./application.css"

console.log('Vite ⚡️ Rails — MEDFLECT')

// ── Stimulus ────────────────────────────────
import { Application } from "@hotwired/stimulus"
const application = Application.start()
application.debug = false
window.Stimulus = application

// ── Controllers ─────────────────────────────
import VoicePreviewController from "../controllers/voice_preview_controller"
import DurationSelectController from "../controllers/duration_select_controller"

application.register("voice-preview", VoicePreviewController)
application.register("duration-select", DurationSelectController)

console.log('✅ Stimulus loaded — voice-preview + duration-select controllers registered')
